<script lang="ts">
    
    import { fly, fade } from 'svelte/transition';
    import LottiePlayer from "../Components/LottiePlayer.svelte";
    import Loading from '../Components/Loading.svelte';
    import type { Fn } from '../global';
    import { getContext } from 'svelte';
    import { navigate } from 'svelte-navigator';

    const playMainTheme: Fn = getContext('playMainTheme');

    function onStart(): void {
        playMainTheme();
        navigate('/avatar');
    }

</script>

<style lang="scss">

    $logo-height: 120px;

    .view {
        height: calc(100% - #{$logo-height});
    }

    .animation {
        padding-top: 2rem;
        flex: 1 1 0;
        min-height: 0;
    }

    .link {
        margin: 1rem 0;
        text-align: center;

    }

    .start-btn {
        border: none;
        color: #fff;
        font-size: 1.1rem;
        background-color: transparent;
    }

    .logo {
        height: $logo-height;
        width: 100%;
        box-sizing: border-box;
        padding-top: 20px;
        text-align: center;
        position: relative;
        overflow: hidden;

        &::before {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 150%;
            height: 250%;
            border-radius: 50%;
            background-color: #fff;
        }

        img {
            height: 80px;
            position: relative;
            z-index: 2;
        }
    }

</style>

<div class="view">

    <div class="animation" in:fade>
        <LottiePlayer src="/animations/todo_el_grupo.json" />
    </div>

    <div class="link" in:fade={{ delay: 500 }}>
        <button type="button" class="start-btn" on:click={onStart}>PULSA PARA EMPEZAR</button>
    </div>

</div>

<div class="logo" in:fly={{ y: 200 }}>
    <img in:fly={{ y: 100, delay: 50 }} src="/images/logo_telde.png" alt="Ayuntamiento de Telde">
</div>

